import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Grid from '@material-ui/core/Grid'
import Menu from '@material-ui/core/Menu'
import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'

import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

import Button from './Button'
import Loading from './Loading'
import Container from './Container'
import ElytizSrc from '../assets/title.png'


const style = theme => ({
  root: {
    padding: 10,
    background: 'black',
    zIndex: theme.zIndex.drawer + 50,
  },
  title: {
    height: 33,
  },
  container: {
    height: 45,
    width: '100%',
    color: 'white',
    display: 'flex',
    paddingRight: 30,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  autoWidth: {
    width: 'auto',
  },
  emailText: {
    color: 'white',
    marginLeft: 10,
    fontWeight: 300,
    textTransform: 'none',
  },
  buttons: {
    '& > *': {
      marginRight: 30,
    },

    '& > *:last-child': {
      marginRight: 0,
    },
  },
  burgerContainer: {
    marginRight: 16,
  },
  logo: {
    height: '100%',
  },
  burger: {
    width: 20,
    height: 16,
    cursor: 'pointer',
    position: 'relative',
    transform: 'rotate(0deg)',
    transition: '.2s ease-in-out',

    '& > span': {
      left: 0,
      height: 2,
      opacity: 1,
      width: '100%',
      borderRaidus: 4,
      display: 'block',
      position: 'absolute',
      transform: 'rotate(0deg)',
      transition: '.15s ease-in-out',
      background: theme.palette.common.white,

      '&:nth-child(1)': {
        top: 0,
      },

      '&:nth-child(2)': {
        top: 8,
      },

      '&:nth-child(3)': {
        top: 16,
      },
    },
  },
  burgerOpened: {
    '& > span': {
      '&:nth-child(1)': {
        top: 8,
        transform: 'rotate(135deg)',
      },

      '&:nth-child(2)': {
        left: -60,
        opacity: 0,
      },

      '&:nth-child(3)': {
        top: 8,
        transform: 'rotate(-135deg)',
      },
    },
  },
})


const Header = ({
  profile,
  classes,
  onLogout,
  className,
  drawerOpened,
  onToggleDrawer,
}) => {
  const [anchor, setAnchor] = useState(null)
  const handleClick = e => setAnchor(e.target)
  const closeMenu = () => setAnchor(null)

  return (
    <AppBar position="fixed" className={classNames(classes.root, className)} elevation={0}>
      <Container fluid className={classes.container}>
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={onToggleDrawer}
          className={(classes.burgerContainer)}
        >
          <div
            className={classNames(classes.burger, {
              [classes.burgerOpened]: drawerOpened,
            })}
          >
            <span />
            <span />
            <span />
          </div>
        </IconButton>

        <img alt="Elytiz" src={ElytizSrc} className={classes.logo} />

        <Grid
          container
          justify="center"
          alignItems="center"
          className={classNames('flex1', classes.buttons)}
        >
          <Loading
            inline
            className="hidden"
            typographyClassName=""
            typographyVariant="caption"
            text="Synchronization in progress..."
          />
        </Grid>

        <Grid
          container
          justify="flex-end"
          alignItems="center"
          className={classNames(classes.autoWidth, classes.buttons)}
        >
          <Button className="white" onClick={handleClick}>
            <Avatar src={profile && profile.picture && profile.picture.original} />
            <Typography variant="body1" className={classes.emailText}>{profile && profile.email}</Typography>
            <KeyboardArrowDownIcon className="ml1" />
          </Button>
        </Grid>

        <Menu
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={closeMenu}
        >
          <MenuItem button onClick={onLogout}><PowerSettingsNewIcon /> Logout</MenuItem>
        </Menu>
      </Container>
    </AppBar>
  )
}


Header.defaultProps = {
  profile: {},
}


Header.propTypes = {
  onLogout: PropTypes.func,
  profile: PropTypes.object,
  drawerOpened: PropTypes.bool,
  onToggleDrawer: PropTypes.func,
  classes: PropTypes.object.isRequired,
}


export default withStyles(style)(Header)
